<div class="pre-audit" [formGroup]="form">
	<div class="pre-audit-checkbox-wrapper">
		<nb-checkbox id="pre-audit-checkbox" [status]="'primary'"
					 [formControlName]="'preAuditRequestCheckbox' + standardName" (checkedChange)="onChange()"
					 style="width: 30px; height: 30px"
					 [attr.data-test-id]="'pre-audit-checkbox_' + standardName"
		></nb-checkbox>
		<label>
			@if (showPricing) {
				<span [display-in-one-line]="'Etapa 1'">{{ 'additional-questions.audit-dates.pre-audit-request-with-price' | translate: {price: preAuditCost | price | async} }}</span>
			} @else {
				{{ 'additional-questions.audit-dates.pre-audit-request-no-price' | translate :{manday: preAuditMandays | number} }}
			}
			<svg-icon src="assets/icons/info.svg" class="info-icon" [ngClass]="{'clicked': preAuditDateInfoVisible}" (click)="togglePreAuditInfo()"></svg-icon>
		</label>
	</div>
	@if ((priceConfigChanged$ | async) && preAuditChecked && clientLogged) {
		<div class="info-message">{{ 'order-edit.price-change-approve.base-price-changed-pre-audit' | translate }}</div>
	}
	@if (preAuditDateInfoVisible) {
		<div class="pre-audit-info">
			{{ 'additional-questions.audit-dates.pre-audit-explanation' | translate }}
		</div>
	}
</div>
